
    import "src/shared/columns/Catalog/index.module.scss?farm_css_modules";
    
    export default {"ellipsis": `ellipsis-4ccd5efb`,"skuDetail": `skuDetail-4ccd5efb`,"sub": `sub-4ccd5efb`,"tag": `tag-4ccd5efb`,"wFull": `wFull-4ccd5efb`,"wrapper": `wrapper-4ccd5efb`}
    